export const SystemErrors = {}
SystemErrors[0] = "Lamport balance below rent-exempt threshold"
SystemErrors[1] = "Insufficient funds. Some transactions require at least 0.03 SOL"
SystemErrors[2] = "Invalid Mint"
SystemErrors[3] = "Account not associated with this Mint"
SystemErrors[4] = "Owner does not match"

SystemErrors[5] = "Fixed supply"
SystemErrors[6] = "Already in use"
SystemErrors[7] = "Invalid number of provided signers"
SystemErrors[8] = "Invalid number of required signers"
SystemErrors[9] = "State is uninitialized"

SystemErrors[10] = "Instruction does not support native tokens"
SystemErrors[11] = "Non-native account can only be closed if its balance is zero"
SystemErrors[12] = "Invalid instruction"
SystemErrors[13] = "State is invalid for requested operation"
SystemErrors[14] = "Operation overflowed"

SystemErrors[15] = "Account does not support specified authority type"
SystemErrors[16] = "This token mint cannot freeze accounts"
SystemErrors[17] = "Account is frozen"
SystemErrors[18] = "The provided decimals value different from the Mint decimals"
SystemErrors[19] = "Instruction does not support non-native tokens"
